import React from 'react';
import PropTypes from 'prop-types';

import { formatISO } from 'date-fns';
import i18n from 'i18next';
import sortBy from 'lodash/sortBy';

import { Typo } from 'uikit/content';
import VideoAgendaSection from './videoAgendaSection';
import styles from '../styles/videoAgenda.module.scss';

/* eslint-disable camelcase */
const VideoAgenda = ({
  agendaItems = [],
  eventEndAt,
  eventStartAt,
  isEnrolled = false,
  selectedAgendaItem,
  viewAgendaItem,
}) => {
  const sortedAgendaItems = sortBy(agendaItems, [
    (item) => new Date(`${item.start_date}T${item.start_time}Z`),
  ]);

  const agendaItemsByDate = sortedAgendaItems.reduce((memo, item) => {
    // agenda items always returned as UTC
    const date = new Date(`${item.start_date}T${item.start_time}Z`);
    const dateKey = formatISO(date, { representation: 'date' });

    // eslint-disable-next-line no-param-reassign
    memo[dateKey] ||= [];
    memo[dateKey].push(item);
    return memo;
  }, {});

  const renderSections = () =>
    Object.keys(agendaItemsByDate).map((key) => (
      <VideoAgendaSection
        key={key}
        agendaItems={agendaItemsByDate[key]}
        isEnrolled={isEnrolled}
        selectedAgendaItem={selectedAgendaItem}
        viewAgendaItem={viewAgendaItem}
        eventStartAt={eventStartAt}
        eventEndAt={eventEndAt}
      />
    ));

  return (
    <div>
      <div className={styles.title_container}>
        <Typo element="h3" variant="d04" className={styles.title}>
          {i18n.t('agenda')}
        </Typo>
      </div>
      {renderSections()}
    </div>
  );
};

VideoAgenda.propTypes = {
  agendaItems: PropTypes.arrayOf(PropTypes.shape({})),
  isEnrolled: PropTypes.bool,
};

export default React.memo(VideoAgenda);
